import React from 'react'
import SelectComponent from '../../ReusableComponents/SelectComponent';
import { BES_INCENTIVE_STATUS } from '../../appConstants';

export default function IncentiveDetailsHeader({
  options,
  incentiveStatus,
  handleStatusChange
}) {
  return (
    <div className="flex justify-between items-center  px-4 py-4 border-b  border-b-[#D9D9D9] ">
      <h4 className="font-manrope font-[700] ml-[8px] text-[18px] text-[#1E1E1E]">
        Incentive Details 
      </h4>
      <div className="mr-10 flex gap-4 items-center">
       
        {
          <div className="flex items-center">
            <p className="me-3">Status : </p>
              <SelectComponent
                list={options.map((status)=>({
                  label:status===BES_INCENTIVE_STATUS.SUBMITTED?"Paid":status,
                  value:status
                }))}
                value={incentiveStatus? {label:incentiveStatus===BES_INCENTIVE_STATUS.SUBMITTED?"Paid":incentiveStatus,value:incentiveStatus} :null}
                onChange={(status) => {
                    handleStatusChange(status.value)
                }
                }
                isDisabled={false}
                controlStyle={{ height: "40px", width: "200px", minHeight: "20px", border: "1px solid black", color: "hsl(0deg 0% 20% / 64%)" }}
              />
            </div>
        }
      </div>
    </div>
  )
}
